/* eslint-disable global-require */

import { isStandaloneApp } from 'app/utils/browser';

export type NavigationItem = {
    type: 'category' | 'dish';
    id: string;
    trackId?: string,
    title: string;
    icon?: string;
};

const nyNavigationConfig: NavigationItem[] = [
    {
        type: 'category',
        id: 'sets',
        title: 'Сеты',
        icon: undefined,
    },


    {
        type: 'category',
        id: 'dessert',
        title: 'Сладости',
        icon: undefined,
    },
    {
        type: 'category',
        id: 'main',
        title: 'Главные блюда',
        icon: undefined,
    },
    {
        type: 'category',
        id: 'salads',
        title: 'Салаты и закуски',
        icon: undefined,
    },
    {
        type: 'category',
        id: 'drinks',
        title: 'Напитки',
        icon: undefined,
    },
    {
        type: 'category',
        id: 'niceStuff',
        title: 'Деликатесы',
        icon: undefined,
    },
    {
        type: 'category',
        id: 'sauсes',
        title: 'Домашние соусы',
        icon: undefined,
    },
    {
        type: 'category',
        id: 'gifts',
        title: 'Сертификаты',
        icon: undefined,
    },
];

export const navigationConfig: Record<string, NavigationItem[]> = {
    'blyuda-dlya-novogodnego-stola': nyNavigationConfig.filter((item) => {
        if (isStandaloneApp()) {
            return item.id !== 'ym';
        }
        return true;
    }),
};


export function findTargetByNavigationItem(navigationItem: NavigationItem) {
    const { type, id } = navigationItem;
    if (type === 'category') {
        return document.getElementById(`category-${id}`);
    }
    if (type === 'dish') {
        return document.getElementById(`dish_${id}`);
    }
    return null;
}
